export const SettingsSection = {
  extends: 'Group',
  Title: {
    flow: 'x',
    width: '100%',
    margin: 'A - -',
    align: 'center space-between',
    text: '{{ settings.section.platform | polyglot }}',
    QuestionMarkTooltip: {
      margin: '0',
      TooltipHidden: {
        minWidth: 'none',
        padding: 'Z A',
        shapeDirection: 'top',
        description: (el) => el.call('polyglot', 'settings.section.resetTooltip')
      },
      Icon: {
        fontSize: 'A2',
        opacity: '.65',
        name: 'refresh'
      }
    }
  },
  Grid: {
    margin: 'A -',
    templateColumns: 'repeat(4, 1fr)',
    gap: 'B1 C3',
    '@tabletM': {
      columns: 'repeat(3, 1fr)'
    },
    '@tabletS': {
      columns: 'repeat(2, 1fr)'
    },
    '@mobileL': {
      columns: 'repeat(1, 1fr)'
    },
    childExtends: 'OptionToggle'
  }
}
